export enum SocialItemPlatform {
  FB = 'facebook',
  IG = 'instagram',
  DC = 'discord',
  YT = 'youtube',
}
